import OtherPromoCard from 'ui/components/molecules/OtherPromoCard';
import { Article } from '../../../interface';

interface IProps {
  items: Article[];
  handleCollectDataLayer?: (props: {
    id: string | number;
    name: string;
    creative: string;
    position: string;
  }) => void;
  handleShowModalExpiredPromo?: () => void;
  enableSharing?: boolean;
  optimize?: boolean;
  categoryGTM?: string;
}

const OtherPromo = ({
  categoryGTM,
  handleCollectDataLayer,
  items,
  enableSharing = false,
  handleShowModalExpiredPromo,
  optimize,
}: IProps) => {
  return (
    <div
      className="w-full overflow-x-auto snap-x snap-mandatory grid gap-2.5 grid-flow-col no-scrollbar lg:grid-cols-4 lg:gap-6"
      style={{
        gridAutoColumns: `calc(100% / 2 - 0.625rem)`,
      }}
    >
      {items.map((item, idx) => (
        <OtherPromoCard
          key={idx}
          categoryGTM={categoryGTM}
          handleCollectDataLayer={handleCollectDataLayer}
          data={item}
          idx={idx}
          enableSharing={enableSharing}
          handleShowModalExpiredPromo={handleShowModalExpiredPromo}
          optimize={optimize}
        />
      ))}
    </div>
  );
};

export default OtherPromo;
